import { Link } from "react-router-dom"

const Notfound = () => {
    return (  
        <div>
            
                <h1 className="not-found">Sorry Resource not available !</h1>
                <Link to="/"><h2><u>Go to Home?</u></h2></Link>
        </div>
    );
}
 
export default Notfound;